import { Component, OnInit } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { LoginService } from "src/app/services/login.service";
import {
  AlertController,
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { LoadingComponent } from "src/app/core-files/loaders/Loader";
import { SideBarEventService } from "src/app/services/event-Emitter/side-bar.service";
import { AdminService } from "src/app/services/admin.service";
import { Device } from "@capacitor/device";
import { Subscription } from "rxjs";
import { SharedServices } from "src/app/services/shared.service";
import { max } from "rxjs/operators";
import { LeadsService } from "src/app/services/leads.service";
import { EncryptionService } from "src/app/services/encryption.service";
import { ToastComponent } from "src/app/core-files/loaders/toast-messages";
import { SharedService } from "src/app/core-files/shared.service.";
import { Capacitor } from "@capacitor/core";
import { PushNotificationService } from "src/app/services/push-notification.service";
import { NotificationsService } from "src/app/services/notifications.service";

@Component({
  selector: "app-user-login",
  templateUrl: "./user-login.page.html",
  styleUrls: ["./user-login.page.scss"],
  standalone: false
})
export class UserLoginPage implements OnInit {
  userId: any;
  config = {
    allowNumbersOnly: false,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputStyles: {
      width: "40px",
      height: "40px",
    },
  };
  mobileForm: UntypedFormGroup;
  registerForm: UntypedFormGroup;
  mobileform = {
    MobileNo: "",
    AgentCode: "",
  };
  isOTPSend: boolean = false;
  userDetails: any;
  invalidOTP: boolean = false;
  isvalid: boolean = false;
  sub: Subscription;
  otp: any;
  smsOTP: any;
  isImageSize: any;
  isCounter: boolean = false;
  configTimer = {
    leftTime: 30,
  };
  agentEmpLoginObject: any = {};
  isAgentUserLoginValue: boolean = false;
  validationResult: any = [];
  isValidateState: boolean = false;
  expirationDate: any;
  reamDays: any;
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private loginService: LoginService,
    public toastController: ToastController,
    public loadingComponent: LoadingComponent,
    private sideBarEventService: SideBarEventService,
    public loadingController: LoadingController,
    private adminService: AdminService,
    public alertController: AlertController,
    private modalCtrl: ModalController,
    private sharedServices: SharedServices,
    private sharedService: SharedService,
    private leadService: LeadsService,
    private encryptionService: EncryptionService,
    private toastComponent: ToastComponent,
    private notificationsService: NotificationsService,
    private pushNotificationService: PushNotificationService,
  ) {
    this.mobileForm = this._formBuilder.group({
      MobileNo: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      AgentCode: [""],
    });


    setTimeout(() => {
      this.mobileno();
    }, 1000);
  }

  back() {
    this.isOTPSend = false;
  }

  ngOnInit() {
    // this.mobileForm.get('AgentCode').valueChanges.subscribe(() => {
    //   this.AgentCode();
    // });
  }
  reSendOTP() {
    const mobileControl = this.mobileForm.get("MobileNo");
    if (!mobileControl || mobileControl.invalid) {
      this.toastComponent.showToast(
        "Please enter a valid mobile number",
        "danger"
      );
      return;
    }

    this.invalidOTP = false;
    this.otp = "";
    this.isvalid = false;
    this.ValidateLoginUser();
  }
  isAgentUserLogin() {
    this.isAgentUserLoginValue = true;
    this.mobileForm
      .get("AgentCode")
      .setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
      ]);
  }

  signUp() {
    this.modalCtrl.dismiss();
    this.sharedServices.openUserSignUpModal();

  }



  backToAgentLogin() {
    this.isAgentUserLoginValue = false;
    this.mobileForm.get("AgentCode").clearValidators();
    this.mobileForm.get("AgentCode").updateValueAndValidity();
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  ValidateLoginUser() {
    let validateObject: any = {
      OtpType: "Mobile",
      OtpValue: this.mobileForm.value.MobileNo,
      UserType: "MainAgent",
      AgentKey: this.mobileForm.value.AgentCode,
    };
    if (this.isAgentUserLoginValue) {
      validateObject.UserType = "AgentUser";
    } else {
      validateObject.UserType = "MainAgent";
    }
    this.loginService.ValidateLoginUser(validateObject).subscribe({
      next: async (res) => {
        this.toastComponent.showToast("OTP sent successfully", "success");
        this.isOTPSend = true;
        this.userId = res.UserId;
      },
      error: (err) => {
        this.toastComponent.showToast(
          "Entered mobile number is incorrect",
          "danger"
        );
      }
    });
  }

  sendMobileOTP() {
    this.ValidateLoginUser();
  }

  async ValidateAgentUser(object, isSave) {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Sending OTP...",
    });
    this.leadService.ValidateAgentUser(object).subscribe({
      next: async (res) => {
        this.isOTPSend = true;
        if (isSave) {
          this.userDetails = res;

          this.sharedService.setUserLoggedIn(true);

          this.adminService
            .ValidateUser(this.userDetails.MainAgentId)
            // .ValidateUser(this.sharedServices.getAgentId())
            .subscribe({
              next: async (res: any) => {
                this.validationResult = res;

               

                if (this.validationResult && this.validationResult.length != 0) {
                  if (
                    this.validationResult[0].validateState == "Active" ||
                    this.validationResult[0].validateState == "Grace Period"
                  ) {
                    this.isValidateState = true;
                  } else {
                    this.isValidateState = false;
                  }
                  this.expirationDate = this.validationResult[0].ExpiryDate;
                  this.calculateDiff(this.validationResult[0].ExpiryDate);
                  if (this.validationResult[0].validateState == "Active" || this.validationResult[0].validateState == "Grace Period") {
                    localStorage.setItem("i_Ex_p", this.encryptionService.encryptUsingAES256("true"));
                    localStorage.setItem(
                      "a_n_d",
                      this.encryptionService.encryptUsingAES256(
                        this.userDetails.MainAgentId
                      )
                    );
                    localStorage.setItem(
                      "ag_u_d",
                      this.encryptionService.encryptUsingAES256(this.userDetails.Id)
                    );
                    localStorage.setItem("tk_n", this.userDetails.AccessToken);
                    localStorage.setItem("U_Name", this.userDetails.Name);
                    localStorage.setItem(
                      "ur_ro_i",
                      this.encryptionService.encryptUsingAES256(
                        this.userDetails.UserRoleId
                      )
                    );
                    localStorage.setItem(
                      "i_Ex_p",
                      this.encryptionService.encryptUsingAES256("false")
                    );
                    localStorage.setItem(
                      "i_a_nt",
                      this.encryptionService.encryptUsingAES256("false")
                    );
                    localStorage.setItem(
                      "lg_d_i",
                      this.encryptionService.encryptUsingAES256("true")
                    );
                    this.adminService.isAuthenticated.next(true);
                    setTimeout(() => {
                      this.leadService.setuserLogoutLogin(true);
                    }, 500);
                    this.modalCtrl.dismiss();
                    // this.router.navigate(["agent-home/agent-tab/home"], {
                    //   replaceUrl: true,
                    // });
                    const toast = await this.toastController.create({
                      message: "Login Successfully",
                      position: "top",
                      duration: 2000,
                      color: "success",
                    });
                    toast.present();
                    this.sideBarEventService.toggleIsLoaded(true);
                  }
                  else {
                    localStorage.setItem("i_Ex_p", this.encryptionService.encryptUsingAES256("false"));
                    this.sharedServices.opneInfoDialog('Subscription', 'Please subscribe to continue using the application.');
                    this.modalCtrl.dismiss();
                  }
                  // else if (this.validationResult[0].validateState == "Grace Period") {
                  //   localStorage.setItem("i_Ex_p", this.encryptionService.encryptUsingAES256("true"))
                  // }load
                }
                else {
                  localStorage.setItem("i_Ex_p", this.encryptionService.encryptUsingAES256("false"));
                  this.sharedServices.opneInfoDialog('Subscription', 'Please subscribe to continue using the application.');
                  this.modalCtrl.dismiss();
                }
                window.location.reload();


              }
            });
          // this.SaveSession(object);
          await loading.dismiss();
        } else {
        }

        await loading.dismiss();
      },
      error: async (err) => {
        await loading.dismiss();
        this.toastComponent.showToast("Invalid Agent Code", "danger");
      }
    });
  }
  
  calculateDiff(sentDate) {
    let date1: any = new Date(sentDate);
    let date2: any = new Date();
    this.reamDays = Math.floor((date1 - date2) / (1000 * 60 * 60 * 24));
    // this.reamDays = this.reamDays ;
  }
  mobileno() {
    const mobileControl = this.mobileForm.get("MobileNo");
    if (mobileControl) {
      mobileControl.setErrors({ invalid: true });
    }
  }

  handleEvent(event) {
    if (event.action == "done") {
      this.isCounter = true;
    }
  }
  onOtpChange(otp) {
    this.otp = otp;
    this.invalidOTP = false;
    if (otp.length === 4) {
      this.isvalid = true;
    } else {
      this.isvalid = false;
    }
  }


  submitOTP() {
    // Test/demo mobile number: skip backend OTP verification and login as MainAgent.
    if (this.mobileForm.value.MobileNo === "1111111111") {
      if (this.otp === "1234") {
        this.LoginAsOTP(this.userId);
      } else {
        this.invalidOTP = true;
        this.toastComponent.showToast("Invalid OTP", "danger");
      }
      return;
    }

    this.loginService.ValidateOTP(this.userId, this.otp).subscribe({
      next: async (res) => {
        if (res) {
          if (res.IsMainAgent) {
            this.LoginAsOTP(res.UserId);
          } else {
            this.agentEmpLoginObject = {
              MobileNo: this.mobileForm.value.MobileNo,
              AgentCode: this.mobileForm.value.AgentCode,
            };
            this.ValidateAgentUser(this.agentEmpLoginObject, true);
          }
        }
      },
      error: async (err) => {
        this.invalidOTP = true;
        this.toastComponent.showToast("Invalid OTP", "danger");
      }
    });
  }

  async LoginAsOTP(UserId) {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Login in...",
    });
    await loading.present();

    this.loginService.loginWithOTP(UserId).subscribe({
      next: async (res) => {
        this.userDetails = res;
         if (Capacitor.isNativePlatform()) {
                  // await this.pushNotificationService.initPushNotifications();

                  const deviceId = (await Device.getId()).identifier;
                  const deviceToken = this.pushNotificationService.getDeviceToken();
                  const deviceType = Capacitor.getPlatform();

                  // setTimeout(() => {
                    let object: any = {
                      MobileDeviceId: deviceId,
                      DeviceType: deviceType,
                      DeviceToken: deviceToken,
                      UserId:  UserId,
                    };

                    this.notificationsService.SaveDeviceDetails(object).subscribe((res) => {
                      // 
                    });
                  // }, 1000);
                
                }
        localStorage.setItem(
          "a_n_d",
          this.encryptionService.encryptUsingAES256(this.userDetails.UserId)
        );
        localStorage.setItem("tk_n", this.userDetails.AccessToken);
        localStorage.setItem(
          "u_ty_i",
          this.encryptionService.encryptUsingAES256(this.userDetails.UserTypeId)
        );
        localStorage.setItem("U_Name", this.userDetails.FName);
        localStorage.setItem(
          "i_Ex_p",
          this.encryptionService.encryptUsingAES256("false")
        );
        localStorage.setItem(
          "i_a_nt",
          this.encryptionService.encryptUsingAES256("true")
        );
        localStorage.setItem(
          "lg_d_i",
          this.encryptionService.encryptUsingAES256("true")
        );
        this.adminService.isAuthenticated.next(true);
        setTimeout(() => {
          this.leadService.setuserLogoutLogin(true);
        }, 500);
        this.modalCtrl.dismiss();
        this.router.navigate(["agent-home/agent-tab/home"], {
          replaceUrl: true,
        });
        const toast = await this.toastController.create({
          message: "Login Successfully",
          position: "top",
          duration: 2000,
          color: "success",
        });
        toast.present();
        this.sideBarEventService.toggleIsLoaded(true);
        await loading.dismiss();
        window.location.reload();
      },
      error: async (error) => {
        const toast = await this.toastController.create({
          message: "Login fail try again",
          position: "top",
          duration: 2000,
          color: "danger",
        });
        toast.present();
        await loading.dismiss();
      }
    });
  }

  // SaveSession(object) {
  //   this.loginService.SaveSession(object).subscribe((res: any) => { });
  // }

}
